<template>
<div class="highscore">
    <div class="score-head">
        <p class="top10 minor">Top 10</p>
        <!-- <p class="rank minor">Rank</p> -->
        <p class="rank minor">Debaters</p>
        <p class="votes minor">Votes</p>
    </div>
    
    <div v-for="(score, index) in $store.state.top10" :key="score.id">
        <div class="score" @click="togglePopMess('Profiles are coming soon')">
            <h1 class="index">#{{index+1}}</h1>
            <h1 class="name">{{score.name}}</h1>
            <h1 class="vote">{{score.votes}}</h1>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'Highscore',
  created() {
    this.getTop10()
  },
  methods: {
    getTop10() {
      this.$store.dispatch('fetchTop10')
    },
    togglePopMess(payload) {
      this.$store.commit('togglePopMess', payload)
    },
  }
}
</script>
<style lang="scss" scoped>
.highscore {
    margin: $main-margin 0;
    .score-head, .score {
        padding: 0 $grid-padding;
        display: flex;
        .top10, .index {
            min-width: $col2;
            max-width: $col2;
        }
        .top10, .index {
            margin-right: $main-margin;
        }
        .rank, .name {
            width: 100%;
        }
        .votes, .vote {
            display: flex;
            width: auto;
            justify-content: flex-end;
        }
    }
    .score-head {
        border-bottom: $line-bold solid $line-color-dark;
    }
    .score {
        border-bottom: $line-thin solid $line-color-light;
        @media #{$no-mob-hover} {
            &:hover {
                cursor: pointer;
                background-color: $black;
                .index {
                    color: $white;
                }
                .name {
                    color: $white;
                    padding-left: 20px !important;
                    transition: padding 50ms ease-in-out;
                }
                .vote {
                    color: $icon-hover-color;
                }
            }
        }
    }
}
// MOBILE
@media #{$mobile} {    
    .highscore {
        margin: 0;
        .score-head, .score {
            padding: 0 $main-margin-mobile;
        }
        .score-head {
            border-bottom: $line-thin solid $line-color-dark;
        }
    }
}


</style>
